import { HeaderService } from './header.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ResultData } from '../_models/ResultData';

@Injectable({
  providedIn: 'root'
})
export class CurriculumService {


  constructor(
    private http: HttpClient,
    private headerService:HeaderService) {}

    getCurricularById(factId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/curriculum/getById/${factId}`,{headers:hh})

    }
    getCurricula():Observable<ResultData> {
      const hh = this.headerService.bearerJsonHeaders()
        return this.http.get<ResultData>(`${environment.apiUrl}/curriculum/listAll`,{headers:hh})

      }
}
